import axios from 'axios';

const API_BASE_URL = process.env.REACT_APP_API_URL || '/api';

const api = axios.create({
  baseURL: API_BASE_URL,
  headers: {
    'Content-Type': 'application/json',
  },
});

// Add token to requests
api.interceptors.request.use(
  (config) => {
    const token = localStorage.getItem('authToken');
    if (token) {
      config.headers.Authorization = `Bearer ${token}`;
    }
    return config;
  },
  (error) => Promise.reject(error)
);

// Handle responses
api.interceptors.response.use(
  (response) => response,
  (error) => {
    if (error.response?.status === 401) {
      localStorage.removeItem('authToken');
      window.location.href = '/login';
    }
    return Promise.reject(error);
  }
);

// Auth endpoints
export const authAPI = {
  register: (data) => api.post('/auth/register', data),
  login: (data) => api.post('/auth/login', data),
  getCurrentUser: () => api.get('/auth/me'),
};

// Message endpoints
export const messageAPI = {
  getMessages: (params) => api.get('/messages', { params }),
  getStats: () => api.get('/messages/stats'),
  sendMessage: (data) => api.post('/messages/send', data),
  getMessage: (id) => api.get(`/messages/${id}`),
  deleteMessage: (id) => api.delete(`/messages/${id}`),
};

// Settings endpoints
export const settingsAPI = {
  getConfigurations: () => api.get('/settings'),
  addWhatsAppConfig: (data) => api.post('/settings/whatsapp-config', data),
  updateConfiguration: (configId, data) => api.put(`/settings/${configId}`, data),
  deleteConfiguration: (configId) => api.delete(`/settings/${configId}`),
  getWebhookToken: (configId) => api.get(`/settings/${configId}/webhook-token`),
};

export default api;
